import React from "react";
import "./businessUnitOverviewSkeleton.css"; // Custom CSS for the shimmer effect

function BusinessUnitOverviewSkeleton() {
  return (
    <div className="buoverview-skeleton-card" >
      {/* Body placeholder */}
      <div className="card-body">
        
        
          {[...Array(6)].map((_, index) => (
           <h3 className="card-title baseSkeleton buoverview-skeleton-text"></h3>
          ))}
      

        {/* Five small cards in a row */}
        <div className="buoverview-skeleton-row">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="baseSkeleton buoverview-skeleton-small-card"></div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BusinessUnitOverviewSkeleton;
